import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
const SchoolProjects = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 rtl">
      {/* Header */}
      <div className="relative overflow-hidden min-h-[40vh] flex items-center">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-100 via-cyan-200 to-teal-200"></div>
          <div className="absolute inset-0 opacity-25">
            <div className="absolute top-20 left-20 w-96 h-96 bg-gradient-to-br from-cyan-200/30 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-br from-teal-200/25 to-transparent rounded-full blur-3xl"></div>
          </div>
        </div>
        
        <div className="relative container mx-auto px-6 py-20">
          <div className="text-center max-w-4xl mx-auto">
            <Button onClick={() => navigate('/')} className="mb-8 bg-blue-600/80 hover:bg-blue-700/80 text-white border border-blue-500/50 font-medium px-6 py-3 rounded-xl shadow-lg">
              <ArrowRight className="w-4 h-4 mr-2" />
              חזרה לדף הבית
            </Button>
            
            <h1 className="text-4xl md:text-6xl font-bold text-blue-900 leading-tight mb-6">
              הובלת פרוייקטים בית ספריים
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-16">
        <Card className="max-w-4xl mx-auto bg-white/80 backdrop-blur-md border border-white/50 shadow-2xl rounded-3xl">
          <CardContent className="p-8">
            <div className="text-right text-lg leading-relaxed text-slate-700 font-rounded" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
              <p className="mb-8">בדף זה מוצגים פרויקטים בית- ספריים המשקפים תהליכים להטמעת ערכים בתרבות הבית-ספרית. התהליכים מפורטים משלב המטרות והתכנון ועד היישום בשטח. שמות ילדים ותמונותיהם טושטשו או הוסרו, בהתאם לכללי האתיקה והחיסיון.</p>
              
              {/* PDF Project Booklet Card - Fuchsia Theme */}
              <div className="bg-fuchsia-50 border-2 border-fuchsia-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-fuchsia-900 font-medium mb-4">מצגת המתארת תהליך להטמעת ערכים של הכלה וסובלנות בתרבות הבית ספרית (תשע״ה, 2015).</p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                  <a href="https://drive.google.com/file/d/1br7i75tv36Yp6zIKsVre-D8Vc10WlATS/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-fuchsia-600 to-fuchsia-700 hover:from-fuchsia-700 hover:to-fuchsia-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                    <FileText className="w-5 h-5" />
                    <span className="text-lg">לצפייה בתוצר (PDF)</span>
                  </a>
                </div>
              </div>
              
              {/* Second PDF Project Card - Cyan Theme */}
              <div className="bg-cyan-50 border-2 border-cyan-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-cyan-900 font-medium mb-4">מצגת המתארת תהליך מערכתי חינוכי-ערכי, בתחום החינוך הסביבתי (תשע״ה, 2015).</p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                  <a href="https://drive.google.com/file/d/1GEyGoPjUouX6OHc7rBdGJSmOt6BtXgQE/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-cyan-600 to-cyan-700 hover:from-cyan-700 hover:to-cyan-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                    <FileText className="w-5 h-5" />
                    <span className="text-lg">לצפייה בתוצר (PDF)</span>
                  </a>
                </div>
              </div>
              
              {/* Third PDF Project Card - Amber Theme */}
              <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-amber-900 font-medium mb-4">
                  חוברת המציגה פרוייקט חינוכי־ערכי ארוך טווח, של הטמעת ערכי התרבות העברית בבית הספר. החוברת כוללת דוגמאות לפעילויות, טקסטים ותוצרים חינוכיים, כפי שהוצגו בחוברת המקורית. לאחר טשטוש שמות ותמונות תלמידים (תשע״ג, 2013).
                </p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                  <a href="https://drive.google.com/file/d/1kdv19qQYI4IOV0mE_XTO2QLN0Iwa79Mv/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                    <FileText className="w-5 h-5" />
                    <span className="text-lg">לצפייה בתוצר (PDF)</span>
                  </a>
                </div>
              </div>
              
              {/* Fourth PDF Project Card - Indigo Theme */}
              <div className="bg-indigo-50 border-2 border-indigo-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-indigo-900 font-medium mb-4">מצגת המתארת תהליך מערכתי חינוכי-ערכי, בתחום החינוך לבטיחות בדרכים (תשע״ב, 2012).</p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                  <a href="https://drive.google.com/file/d/1AttIcaROr1gX8G7OlToFPtTnPwfz5H5f/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                    <FileText className="w-5 h-5" />
                    <span className="text-lg">לצפייה בתוצר (PDF)</span>
                  </a>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
};
export default SchoolProjects;